import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../config/api.config';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background-color: #f5f6fa;
`;

const Card = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 500px;
  text-align: center;
`;

const Title = styled.h1`
  color: #2d3748;
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
`;

const Message = styled.p`
  color: #4a5568;
  font-size: 1rem;
  margin-bottom: 2rem;
`;

const Button = styled.button`
  padding: 0.75rem 2rem;
  border-radius: 25px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  background: #ff6b6b;
  color: white;
  border: none;
  
  &:hover {
    background: #ff8e53;
  }
`;

const Success: React.FC = () => {
    const navigate = useNavigate();

    const handleBackToDashboard = () => {
        navigate(APP_ROUTES.DASHBOARD);
    };

    return (
        <Container>
            <Card>
                <Title>Subscription Successful!</Title>
                <Message>
                    Your subscription has been processed successfully. You can now access all features.
                </Message>
                <Button onClick={handleBackToDashboard}>
                    Back to Dashboard
                </Button>
            </Card>
        </Container>
    );
};

export default Success; 